import CardsAdapter from "./Cards";

export { CardsAdapter as Cards };
